import zhCN from './zh-cn.js';
import enUS from './en-us.js';
import jaJP from './ja-jp.js';
import zhTW from './zh-tw.js';
import zhHK from './zh-hk.js';
import msMY from './ms-my.js';
import viVN from './vi-vn.js';
import inID from './in-id.js';
import thTH from './th-th.js';
import esLA from './es-la.js';
import ptBR from './pt-br.js';
import frFR from './fr-fr.js';
import koKR from './ko-kr.js';
import ruRU from './ru-ru.js';
import trTR from './tr-tr.js';

export default {
  'zh-cn': zhCN,
  'zh-tw': zhTW,
  'ja-jp': jaJP,
  'en-us': enUS,
  'zh-hk': zhHK,
  'ms-my': msMY,
  'vi-vn': viVN,
  'in-id': inID,
  'th-th': thTH,
  'es-la': esLA,
  'pt-br': ptBR,
  'fr-fr': frFR,
  'ko-kr': koKR,
  'ru-ru': ruRU,
  'tr-tr': trTR,
};
